// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let Sentry = require("../../reason/Sentry.bs.js");
let MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RelaySharedProperty = require("./RelaySharedProperty.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let RemovedSharedPropertyV5 = require("./RemovedSharedPropertyV5.bs.js");
let Sharing__ClientPageHeader = require("../../reason/sharing/components/Sharing__ClientPageHeader/Sharing__ClientPageHeader.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let TerminatedAgentSharedPropertyV5 = require("./TerminatedAgentSharedPropertyV5.bs.js");
let RelaySharedPropertyPageQuery_graphql = require("../../__generated__/RelaySharedPropertyPageQuery_graphql.bs.js");

let convertVariables = RelaySharedPropertyPageQuery_graphql.Internal.convertVariables;

let convertResponse = RelaySharedPropertyPageQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = RelaySharedPropertyPageQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, RelaySharedPropertyPageQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, RelaySharedPropertyPageQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(RelaySharedPropertyPageQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(RelaySharedPropertyPageQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(RelaySharedPropertyPageQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(RelaySharedPropertyPageQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let defaultMessage = "There was a problem loading the property. Please refresh or try again later...";

function RelaySharedPropertyPage$ErrorState(props) {
  let __message = props.message;
  let message = __message !== undefined ? __message : defaultMessage;
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
    children: JsxRuntime.jsx(ErrorComponent.make, {
      message: message
    })
  });
}

let ErrorState = {
  defaultMessage: defaultMessage,
  make: RelaySharedPropertyPage$ErrorState
};

function RelaySharedPropertyPage$Page(props) {
  let match = use({
    id: props.id
  }, undefined, undefined, undefined);
  let sharedProperty = match.sharedPropertyV5;
  switch (sharedProperty.__typename) {
    case "NotFoundError" :
      return JsxRuntime.jsx(RelaySharedPropertyPage$ErrorState, {
        message: "The link doesn't appear to be valid. Please contact support"
      });
    case "RemovedSharedPropertyError" :
      return JsxRuntime.jsx(RemovedSharedPropertyV5.make, {
        removedSharedProperty: sharedProperty.fragmentRefs
      });
    case "SharedPropertyV5" :
      return JsxRuntime.jsx(RelaySharedProperty.make, {
        sharedProperty: sharedProperty.fragmentRefs
      });
    case "TerminatedSharingAgentError" :
      return JsxRuntime.jsx(TerminatedAgentSharedPropertyV5.make, {
        terminatedAgentSharedProperty: sharedProperty.fragmentRefs
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected union member: ` + sharedProperty._0 + ` in SharedProperty query`);
  }
}

let Page = {
  make: RelaySharedPropertyPage$Page
};

function RelaySharedPropertyPage$LoadingState(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Loader.make, {}),
    className: "items-center justify-center flex grow"
  });
}

let LoadingState = {
  make: RelaySharedPropertyPage$LoadingState
};

function RelaySharedPropertyPage$default(props) {
  let id = props.id;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Sharing__ClientPageHeader.make, {}),
      JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
        FallbackComponent: _error => JsxRuntime.jsx(RelaySharedPropertyPage$ErrorState, {}),
        children: JsxRuntime.jsx(React.Suspense, {
          children: id !== undefined ? JsxRuntime.jsx(RelaySharedPropertyPage$Page, {
              id: id
            }) : JsxRuntime.jsx(RelaySharedPropertyPage$LoadingState, {}),
          fallback: JsxRuntime.jsx(RelaySharedPropertyPage$LoadingState, {})
        }),
        onError: error => Sentry.captureException(error, "RelaySharedPropertyPage.res", undefined, undefined, undefined)
      })
    ],
    className: "flex flex-col grow"
  });
}

let Container;

let $$default = RelaySharedPropertyPage$default;

exports.Container = Container;
exports.Query = Query;
exports.ErrorState = ErrorState;
exports.Page = Page;
exports.LoadingState = LoadingState;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
